import { popoverAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
import { defineStyle } from "@chakra-ui/styled-system";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  popoverAnatomy.keys
);

const baseStyleContent = defineStyle({
  boxShadow: "default",
  bg: "brand.cloudy",
  borderColor: "brand.cloudy",
});

const baseStyle = definePartsStyle({
  content: baseStyleContent,
});

export const popoverTheme = defineMultiStyleConfig({ baseStyle });
